module.exports = __webpack_public_path__ + "v294910/img/switchdoc.d798e50a.png";